"use client";
import { authClient } from "@/lib/client/betterauth/auth-client";
import { FaMicrosoft } from "react-icons/fa";

const LoginMicrosoft = () => {
  const handleSignIn = async () => {
    await authClient.signIn.social({
      provider: "microsoft",
      callbackURL: "/app",
    });
  };

  return (
    <button
      onClick={handleSignIn}
      className="flex h-10 w-full items-center justify-center gap-3 rounded-md border border-input bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground"
      type="button"
    >
      <FaMicrosoft className="h-4 w-4" />
      <span>Continue with Microsoft</span>
    </button>
  );
};

export default LoginMicrosoft;
